module.exports = __webpack_public_path__ + "img/水泥拌合站.4b245971.png";